import { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { getPublicStore, createPreference } from '../services/api';

export default function StorePage() {
  const { clientId } = useParams();
  const [searchParams] = useSearchParams();
  const [store, setStore]       = useState(null);
  const [error, setError]       = useState('');
  const [catFilter, setCatFilter] = useState('Todos');
  const [search, setSearch]     = useState('');
  const [paying, setPaying]     = useState(null);
  const [payLoading, setPayLoading] = useState(false);
  const [qty, setQty]           = useState(1);
  const mpStatus = searchParams.get('mp');

  useEffect(() => {
    getPublicStore(clientId)
      .then(setStore)
      .catch(e => setError(e.message));
  }, [clientId]);

  if (error) return (
    <div style={{ ...styles.wrap, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
      <div style={styles.errBox}>
        <div style={{ fontSize: '48px', marginBottom: '12px' }}>🚫</div>
        <div style={{ color: '#fca5a5', fontSize: '16px' }}>{error}</div>
      </div>
    </div>
  );
  if (!store) return (
    <div style={{ ...styles.wrap, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
      <div style={{ color: 'rgba(255,255,255,0.3)', fontSize: '16px' }}>Cargando tienda…</div>
    </div>
  );

  const color = store.config?.color || '#6C5CE7';
  const moneda = store.config?.moneda || 'ARS';
  const symbol = moneda === 'USD' ? '$' : moneda === 'EUR' ? '€' : '$';
  const whatsapp = store.config?.whatsapp;
  const prods = store.productos || [];

  const cats = ['Todos', ...Array.from(new Set(prods.map(p => p.categoria).filter(Boolean)))];
  const filtered = prods.filter(p => {
    const matchCat = catFilter === 'Todos' || p.categoria === catFilter;
    const matchSearch = !search || p.nombre.toLowerCase().includes(search.toLowerCase()) || p.descripcion?.toLowerCase().includes(search.toLowerCase());
    return matchCat && matchSearch;
  });
  const featured = filtered.filter(p => p.destacado);
  const regular  = filtered.filter(p => !p.destacado);

  const handleBuy = async (prod) => {
    if (!store.config?.mp_enabled) {
      if (whatsapp) {
        const msg = encodeURIComponent(`Hola! Me interesa: ${prod.nombre} - ${symbol}${Number(prod.precio).toLocaleString()}`);
        window.open(`https://wa.me/${whatsapp}?text=${msg}`, '_blank');
      }
      return;
    }
    setPaying(prod); setQty(1);
  };

  const handlePay = async () => {
    if (!paying) return;
    setPayLoading(true);
    try {
      const data = await createPreference(clientId, {
        title: paying.nombre,
        price: paying.precio,
        quantity: qty,
        product_id: paying.id,
      });
      window.location.href = data.checkout_url || data.init_point;
    } catch (e) {
      alert('Error al procesar pago: ' + e.message);
    } finally {
      setPayLoading(false);
    }
  };

  const whatsappAll = () => {
    if (!whatsapp) return;
    window.open(`https://wa.me/${whatsapp}`, '_blank');
  };

  return (
    <div style={{ ...styles.wrap, '--primary': color }}>
      {/* Header */}
      <header style={{ ...styles.header, borderBottomColor: color + '33' }}>
        <div style={styles.headerInner}>
          <div>
            <h1 style={{ ...styles.storeName, color }}>{store.config?.nombre || 'Tienda'}</h1>
            {store.config?.descripcion && <p style={styles.storeDesc}>{store.config.descripcion}</p>}
          </div>
          {whatsapp && (
            <button style={{ ...styles.waBtnNav, background: '#25d366' }} onClick={whatsappAll}>
              <span style={{ fontSize: '16px' }}>💬</span> WhatsApp
            </button>
          )}
        </div>
      </header>

      {/* Status MP */}
      {mpStatus === 'success' && (
        <div style={styles.mpOk}>✅ ¡Pago exitoso! Gracias por tu compra.</div>
      )}
      {mpStatus === 'failure' && (
        <div style={styles.mpErr}>❌ El pago no pudo completarse. Podés intentarlo de nuevo.</div>
      )}
      {mpStatus === 'pending' && (
        <div style={styles.mpWarn}>⏳ Tu pago está pendiente de confirmación.</div>
      )}

      <main style={styles.main}>
        {/* Buscador + filtros */}
        <div style={styles.filterRow}>
          <input
            style={styles.search}
            placeholder="Buscar productos…"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          <div style={styles.cats}>
            {cats.map(c => (
              <button
                key={c}
                style={{
                  ...styles.catBtn,
                  background: catFilter === c ? color : 'rgba(255,255,255,0.06)',
                  color: catFilter === c ? '#fff' : '#94a3b8',
                  border: `1px solid ${catFilter === c ? color : 'rgba(255,255,255,0.1)'}`,
                }}
                onClick={() => setCatFilter(c)}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        {/* Destacados */}
        {featured.length > 0 && (
          <section style={{ marginBottom: '36px' }}>
            <h2 style={styles.sectionTitle}>⭐ Destacados</h2>
            <div style={{ ...styles.grid, gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))' }}>
              {featured.map(p => <ProductCard key={p.id} p={p} color={color} symbol={symbol} moneda={moneda} whatsapp={whatsapp} onBuy={handleBuy} mpEnabled={store.config?.mp_enabled} />)}
            </div>
          </section>
        )}

        {/* Todos los productos */}
        {regular.length > 0 && (
          <section>
            {featured.length > 0 && <h2 style={styles.sectionTitle}>Todos los productos</h2>}
            <div style={styles.grid}>
              {regular.map(p => <ProductCard key={p.id} p={p} color={color} symbol={symbol} moneda={moneda} whatsapp={whatsapp} onBuy={handleBuy} mpEnabled={store.config?.mp_enabled} />)}
            </div>
          </section>
        )}

        {filtered.length === 0 && (
          <div style={{ textAlign: 'center', color: '#475569', padding: '60px 0' }}>
            No se encontraron productos.
          </div>
        )}
      </main>

      {/* Footer */}
      <footer style={styles.footer}>
        <span style={{ color: '#334155' }}>Powered by TiendaSaaS</span>
      </footer>

      {/* MODAL DE COMPRA */}
      {paying && (
        <div style={styles.modal} onClick={() => setPaying(null)}>
          <div style={styles.modalCard} onClick={e => e.stopPropagation()}>
            {paying.imagen && (
              <img src={paying.imagen} alt={paying.nombre} style={styles.modalImg} onError={e => e.target.style.display = 'none'} />
            )}
            <h3 style={{ color: '#f1f5f9', marginBottom: '8px' }}>{paying.nombre}</h3>
            {paying.descripcion && <p style={{ color: '#64748b', fontSize: '14px', marginBottom: '14px' }}>{paying.descripcion}</p>}
            <div style={{ color, fontWeight: 700, fontSize: '22px', marginBottom: '16px' }}>
              {symbol}{Number(paying.precio).toLocaleString()}
            </div>

            <label style={styles.label}>Cantidad</label>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '20px' }}>
              <button style={styles.qtyBtn} onClick={() => setQty(q => Math.max(1, q - 1))}>−</button>
              <span style={{ color: '#f1f5f9', fontWeight: 600, minWidth: '24px', textAlign: 'center' }}>{qty}</span>
              <button style={styles.qtyBtn} onClick={() => setQty(q => q + 1)}>+</button>
              <span style={{ color: '#64748b', fontSize: '14px', marginLeft: '8px' }}>
                Total: {symbol}{(paying.precio * qty).toLocaleString()}
              </span>
            </div>

            <div style={{ display: 'flex', gap: '10px' }}>
              <button style={styles.btnCancel} onClick={() => setPaying(null)}>Cancelar</button>
              <button
                style={{ ...styles.btnPay, background: color, opacity: payLoading ? 0.7 : 1 }}
                onClick={handlePay}
                disabled={payLoading}
              >
                {payLoading ? 'Redirigiendo…' : '💳 Pagar con MercadoPago'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function ProductCard({ p, color, symbol, moneda, whatsapp, onBuy, mpEnabled }) {
  const handleWa = () => {
    if (!whatsapp) return;
    const msg = encodeURIComponent(`Hola! Me interesa: ${p.nombre} - ${symbol}${Number(p.precio).toLocaleString()}`);
    window.open(`https://wa.me/${whatsapp}?text=${msg}`, '_blank');
  };

  return (
    <div style={styles.card}>
      {p.imagen
        ? <img src={p.imagen} alt={p.nombre} style={styles.cardImg} onError={e => e.target.style.display = 'none'} />
        : <div style={styles.cardImgPlaceholder}>📦</div>
      }
      <div style={styles.cardBody}>
        {p.categoria && <span style={styles.catChip}>{p.categoria}</span>}
        <div style={styles.cardName}>{p.nombre}</div>
        {p.descripcion && <div style={styles.cardDesc}>{p.descripcion}</div>}
        <div style={{ ...styles.cardPrice, color }}>{symbol}{Number(p.precio).toLocaleString()}</div>
        <div style={styles.cardActions}>
          {mpEnabled && (
            <button style={{ ...styles.btnBuy, background: color }} onClick={() => onBuy(p)}>
              Comprar
            </button>
          )}
          {whatsapp && (
            <button style={styles.btnWa} onClick={handleWa}>
              💬 {mpEnabled ? '' : 'Consultar'}
            </button>
          )}
          {!mpEnabled && !whatsapp && (
            <span style={{ color: '#475569', fontSize: '13px' }}>Sin método de pago configurado</span>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrap: { minHeight: '100vh', background: '#080b12', fontFamily: "'Segoe UI', sans-serif" },
  header: { borderBottom: '1px solid rgba(255,255,255,0.08)', padding: '20px 0' },
  headerInner: { maxWidth: '1100px', margin: '0 auto', padding: '0 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' },
  storeName: { fontSize: '26px', fontWeight: 700, margin: '0 0 4px' },
  storeDesc: { color: '#64748b', fontSize: '14px', margin: 0 },
  waBtnNav: { padding: '9px 18px', border: 'none', borderRadius: '10px', color: '#fff', fontWeight: 600, fontSize: '14px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', fontFamily: 'inherit' },
  mpOk: { maxWidth: '1100px', margin: '16px auto 0', padding: '12px 24px', background: 'rgba(34,197,94,0.12)', border: '1px solid rgba(34,197,94,0.3)', borderRadius: '10px', color: '#86efac', fontSize: '14px' },
  mpErr: { maxWidth: '1100px', margin: '16px auto 0', padding: '12px 24px', background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '10px', color: '#fca5a5', fontSize: '14px' },
  mpWarn: { maxWidth: '1100px', margin: '16px auto 0', padding: '12px 24px', background: 'rgba(234,179,8,0.12)', border: '1px solid rgba(234,179,8,0.3)', borderRadius: '10px', color: '#fde047', fontSize: '14px' },
  main: { maxWidth: '1100px', margin: '0 auto', padding: '28px 24px' },
  filterRow: { marginBottom: '24px', display: 'flex', flexDirection: 'column', gap: '12px' },
  search: {
    padding: '11px 16px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: '10px', color: '#f1f5f9', fontSize: '14px', outline: 'none',
    fontFamily: 'inherit', maxWidth: '400px',
  },
  cats: { display: 'flex', gap: '8px', flexWrap: 'wrap' },
  catBtn: { padding: '6px 14px', borderRadius: '20px', fontSize: '13px', cursor: 'pointer', fontFamily: 'inherit', transition: 'all 0.15s' },
  sectionTitle: { color: '#f1f5f9', fontSize: '18px', fontWeight: 600, marginBottom: '16px' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '18px' },
  card: {
    background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.07)',
    borderRadius: '14px', overflow: 'hidden', transition: 'transform 0.15s, border-color 0.15s',
  },
  cardImg: { width: '100%', height: '180px', objectFit: 'cover' },
  cardImgPlaceholder: { width: '100%', height: '180px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '40px', background: 'rgba(255,255,255,0.03)' },
  cardBody: { padding: '14px 16px' },
  catChip: { display: 'inline-block', padding: '2px 8px', borderRadius: '6px', fontSize: '11px', color: '#94a3b8', background: 'rgba(255,255,255,0.06)', marginBottom: '8px' },
  cardName: { fontWeight: 600, color: '#f1f5f9', marginBottom: '6px', fontSize: '15px' },
  cardDesc: { color: '#64748b', fontSize: '13px', marginBottom: '10px', lineHeight: '1.5', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' },
  cardPrice: { fontWeight: 700, fontSize: '18px', marginBottom: '12px' },
  cardActions: { display: 'flex', gap: '8px' },
  btnBuy: { flex: 1, padding: '9px', border: 'none', borderRadius: '8px', color: '#fff', fontWeight: 600, fontSize: '13px', cursor: 'pointer', fontFamily: 'inherit' },
  btnWa: { padding: '9px 12px', border: '1px solid rgba(37,211,102,0.3)', borderRadius: '8px', background: 'rgba(37,211,102,0.1)', color: '#86efac', fontSize: '13px', cursor: 'pointer', fontFamily: 'inherit', fontWeight: 500 },
  footer: { textAlign: 'center', padding: '24px', borderTop: '1px solid rgba(255,255,255,0.05)', fontSize: '13px' },
  errBox: { textAlign: 'center', padding: '40px' },
  modal: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, padding: '20px',
  },
  modalCard: {
    background: '#141824', border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: '18px', padding: '28px', width: '100%', maxWidth: '420px',
  },
  modalImg: { width: '100%', height: '200px', objectFit: 'cover', borderRadius: '10px', marginBottom: '16px' },
  label: { display: 'block', color: 'rgba(255,255,255,0.5)', fontSize: '13px', marginBottom: '6px' },
  qtyBtn: {
    width: '32px', height: '32px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.15)',
    background: 'rgba(255,255,255,0.07)', color: '#f1f5f9', fontSize: '18px', cursor: 'pointer', fontFamily: 'inherit',
  },
  btnCancel: { flex: 1, padding: '11px', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '10px', background: 'transparent', color: '#94a3b8', fontSize: '14px', cursor: 'pointer', fontFamily: 'inherit' },
  btnPay: { flex: 2, padding: '11px', border: 'none', borderRadius: '10px', color: '#fff', fontWeight: 600, fontSize: '14px', cursor: 'pointer', fontFamily: 'inherit' },
};
